import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';
import BackButton from './BackButton';
// Color constants (matching AppOnboardingPage theme)

interface StoredUser {
  userId?: string | null;
  email: string | null;
  name?: string | null;
  displayName?: string | null;
  photoURL: string | null;
}

interface UserHeaderProps {
  className?: string;
  showBackButton?: boolean;
}

const UserHeader: React.FC<UserHeaderProps> = ({ className, showBackButton = true }) => {
  const [, setUser] = useState<StoredUser | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // Get user from localStorage
    const loadUser = () => {
      try {
        const storedUser = localStorage.getItem('loggedInUser');
        if (storedUser) {
          const parsed = JSON.parse(storedUser) as StoredUser;
          setUser(parsed);
        } else {
          setUser(null);
        }
      } catch {
        setUser(null);
      }
    };

    loadUser();

    // Listen for storage changes (in case user logs in/out in another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'loggedInUser') {
        loadUser();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [location.pathname]);

  // Always show top bar when this component is mounted (App only mounts it when not on UserPortalPage).
  // Show logo + hamburger regardless of login state so the bar does not disappear on other pages.
  return (
    <div
      className={className}
      style={{
        height: 50,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '6px 16px',
        gap: 12,
        direction: 'ltr',
        boxSizing: 'border-box',
      }}
    >
      {/* Avatar */}
      {/* <div
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          overflow: "hidden",
          flexShrink: 0,
          cursor: "pointer",
          border: `2px solid ${BLUE_ACCENT}`,
          background: user.photoURL ? "transparent" : BLUE_ACCENT,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "transform 0.2s ease, border-color 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {user.photoURL ? (
          <img
            src={user.photoURL}
            alt={user.displayName || "User avatar"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <span
            style={{
              color: "#FFFFFF",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            {getInitials(user.displayName)}
          </span>
        )}
      </div> */}

      {/* User info */}
      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          flex: 1,
        }}
      >
        <span
          style={{
            color: TEXT_DARK,
            fontSize: 14,
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.3,
          }}
        >
          {user.displayName || "User"}
        </span>
        <span
          style={{
            color: TEXT_SECONDARY,
            fontSize: 11,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.3,
          }}
        >
          {user.email}
        </span>
      </div> */}

      {/* Back button */}
      {showBackButton && <BackButton onClick={() => navigate(-1)} />}

      {/* Spacer */}
      <div style={{ flex: 1 }} />

      {/* Hamburger Menu */}
      <HamburgerMenu />
    </div>
  );
};

export default UserHeader;
